import { NgModule } from '@angular/core';
import { EntityDataService, EntityServices } from '@ngrx/data';
import { MedicalSterilizationRepository } from './impl/service/repository/medicalSterilization.repository';
import { MedicalSterilizationDataService } from './impl/service/repository/medicalSterilization.dataservice';
import {errorMessages} from "../../../core/error/errorMessages";

@NgModule({
})
export class MedicalSterilizationSterilizationModule {
  constructor(entityDataService: EntityDataService,
              entityServices: EntityServices,
              repository: MedicalSterilizationRepository,
              dataService: MedicalSterilizationDataService) {
    entityDataService.registerServices({
      MedicalSterilization: dataService
    });
    entityServices.registerEntityCollectionServices({
      MedicalSterilization: repository
    });
    errorMessages.set('MEDICAL_STERILIZATION_SAVE_VALIDATION_DATE_AFTER_STERILIZATION_DATE', 'La date de fin ne validité ne peut être antérieure à la date de stérilisation.');
    errorMessages.set('MEDICAL_STERILIZATION_SAVE_CYCLE_NUMBER_ALREADY_USED', 'Ce numéro de cycle est déjà utilisé');
  }
}

